/*
 * Widget Templates
 * (Handlebars)
 *
 */
import './utils/lib/handlebars-helpers';
Gryphon = Gryphon || {};
Gryphon.templates = {
  'ai-chat': require('./modules/AIChat/ai-chat.hbs'),
  'displaymax-required-message': require('./components/DisplayMaxRequiredMessage/displaymax-required-message.hbs'),
  404: require('./components/NotFound/404.hbs'),
  'grid-cell-input': require('./components/GridCellInput/_grid-cell-input.hbs'),
  open_entry: require('./modules/Open/open_entry.hbs'),
  open_trailer: require('./modules/Open/open_trailer.hbs'),
  popup: require('./modules/Popup/popup.hbs'),
  'response-button': require('./components/ResponseButton/_response-button.hbs'),
  'response-item': require('./components/ResponseItem/_response-item.hbs'),
  'dk-partial': require('./components/DkPartial/dk-partial.hbs'),
  'preview-debug-panel': require('./components/PreviewDebugPanel/preview-debug-panel.hbs'),
};
